import '../../../../styles/oa.scss';
import React from 'react';

function OaImg(props) {
  return (
    <div>
      <img src={props.config.imgUrl} alt="img" />
    </div>
  );
}

export default OaImg;
